import { render } from "./editmarketing.vue?vue&type=template&id=13edea0a"
import script from "./editmarketing.vue?vue&type=script&lang=js"
export * from "./editmarketing.vue?vue&type=script&lang=js"

import exportComponent from "/Users/arthaskyline/Documents/FILE_DELFIN/kodingan-arthaskyline/level-up/levelup-github/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__